const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 425,
    viewBox: "0 0 268 425",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M133.762 0C209.573 0.585448 267.264 59.0331 267.264 129.68C267.264 145.874 261.753 168.18 250.281 187.701C239.148 206.649 222.201 222.757 212.678 241.174C206.947 252.248 201.532 260.238 198.12 271.892C196.142 278.655 194.627 286.123 192.866 293.047C190.052 304.111 179.376 311.954 167.035 311.954H133.762H100.493C88.1517 311.954 77.475 304.111 74.6616 293.047C72.8999 286.123 71.3852 278.655 69.4075 271.892C65.9957 260.238 60.5802 252.248 54.8489 241.174C45.326 222.757 28.3789 206.649 17.2463 187.701C5.77417 168.18 0.263672 145.874 0.263672 129.68C0.263672 59.0331 57.9543 0.585448 133.762 0Z",
    fill: "url(#paint0_linear_719_2551)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.763 389.157H183.555L180.262 394.246C172.8 405.773 161.368 412.509 149.259 412.509H133.763H118.267C106.161 412.509 94.7264 405.773 87.2643 394.246L83.9713 389.157H133.763Z",
    fill: "url(#paint1_linear_719_2551)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.506 414.877C147.345 420.731 141.17 425 133.76 425C126.355 425 120.182 420.731 118.022 414.877H149.506Z",
    fill: "url(#paint2_linear_719_2551)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.785 331.758C79.785 333.692 80.9745 335.261 82.4465 335.261H185.078C186.55 335.261 187.742 333.692 187.742 331.758V322.71C187.742 320.776 186.55 319.212 185.078 319.212H82.4465C80.9745 319.212 79.785 320.776 79.785 322.71V331.758Z",
    fill: "url(#paint3_linear_719_2551)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.785 354.985C79.785 356.915 80.9745 358.479 82.4465 358.479H185.078C186.55 358.479 187.742 356.915 187.742 354.985V345.933C187.742 344.004 186.55 342.439 185.078 342.439H82.4465C80.9745 342.439 79.785 344.004 79.785 345.933V354.985Z",
    fill: "url(#paint4_linear_719_2551)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.785 377.752C79.785 379.681 80.9745 381.25 82.4465 381.25H185.078C186.55 381.25 187.742 379.681 187.742 377.752V368.7C187.742 366.77 186.55 365.206 185.078 365.206H82.4465C80.9745 365.206 79.785 366.77 79.785 368.7V377.752Z",
    fill: "url(#paint5_linear_719_2551)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.074 190.551C141.25 205.964 137.235 222.061 135.312 238.328C135.623 237.816 135.906 237.304 136.188 236.792C145.348 219.871 148.344 204.457 147.074 190.551Z",
    fill: "#97C11D",
    style: {
      fill: "#97C11D",
      fill: "color(display-p3 0.5922 0.7569 0.1137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.567 241.254C127.51 240.828 127.481 240.375 127.424 239.946C127.424 239.946 127.424 239.918 127.396 239.918C125.39 221.546 120.328 203.404 112.695 186.426C110.064 180.51 107.096 174.767 103.875 169.166C93.6394 149.913 79.8168 132.567 63.3042 118.803C84.1117 133.902 101.358 154.236 113.77 177.241C121.292 191.148 127.059 206.049 130.734 221.347C134.015 206.985 138.877 192.939 145.152 179.571C141.845 166.973 135.088 155.769 126.548 145.931C96.4385 111.237 44.3059 93.8066 44.3059 93.8066L44.5029 94.3471C43.1734 100.036 23.8094 227.436 127.567 241.254Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.224 243.136C167.732 238.811 192.692 224.331 209.413 200.097C226.994 174.62 232.065 142.816 233.226 120.623C234.423 97.7199 231.856 79.2486 231.044 75.0059L232.725 71.0713L228.713 72.4128C227.989 72.6546 155.941 97.1771 124.951 144.899C118.251 155.182 113.856 165.952 111.895 176.909C111.335 180.019 110.965 183.188 110.794 186.326C109.842 202.691 114.122 219.782 123.517 237.125C124.111 238.197 124.761 239.256 125.388 240.282L126.326 241.818H127.394V240.067L129.31 240.188C130.06 234.272 131.164 228.073 132.586 221.769C135.82 207.606 140.628 193.679 146.872 180.382C153.228 166.77 160.927 154.046 169.771 142.458C166.307 147.701 163.083 153.127 160.125 158.694C154.348 168.652 149.348 179.164 145.296 189.882C139.336 205.653 135.343 221.878 133.425 238.104C133.334 238.711 133.263 239.382 133.192 240.048C133.156 240.38 133.121 240.707 133.083 241.034L132.798 243.459L135.224 243.136Z",
    fill: "#CAE4EC",
    style: {
      fill: "#CAE4EC",
      fill: "color(display-p3 0.7922 0.8941 0.9255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.191 236.222C125.87 237.445 126.632 238.668 127.396 239.919C127.425 239.919 127.425 239.948 127.425 239.948C128.216 233.721 129.348 227.492 130.732 221.349C134.013 206.987 138.876 192.941 145.151 179.573C159.401 149.061 180.97 121.96 207.773 102.536C189.057 118.12 173.394 137.769 161.803 159.583C156.063 169.478 151.115 179.858 147.074 190.55C141.25 205.963 137.235 222.06 135.312 238.327C135.17 239.294 135.086 240.289 134.973 241.256C252.529 225.615 230.589 81.2653 229.062 74.8112L229.316 74.2139C229.316 74.2139 157.532 98.2149 126.546 145.932C120.355 155.432 115.803 165.869 113.769 177.243C113.232 180.23 112.864 183.299 112.695 186.428C111.817 201.5 115.381 218.109 125.191 236.222Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_2551",
    x1: 133.842,
    y1: 403,
    x2: 126.342,
    y2: -0.00000546472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A7E0F2",
    stopOpacity: 0.2,
    style: {
      stopColor: "#A7E0F2",
      stopColor: "color(display-p3 0.6549 0.8784 0.9490)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB7D9",
    stopOpacity: 0.3,
    style: {
      stopColor: "#4AB7D9",
      stopColor: "color(display-p3 0.2902 0.7176 0.8510)",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_719_2551",
    x1: 133.763,
    y1: 412.509,
    x2: 133.763,
    y2: 389.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB7D9",
    stopOpacity: 0.1,
    style: {
      stopColor: "#4AB7D9",
      stopColor: "color(display-p3 0.2902 0.7176 0.8510)",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7E0F2",
    stopOpacity: 0.2,
    style: {
      stopColor: "#A7E0F2",
      stopColor: "color(display-p3 0.6549 0.8784 0.9490)",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_719_2551",
    x1: 133.764,
    y1: 425,
    x2: 133.764,
    y2: 414.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB7D9",
    stopOpacity: 0.1,
    style: {
      stopColor: "#4AB7D9",
      stopColor: "color(display-p3 0.2902 0.7176 0.8510)",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7E0F2",
    stopOpacity: 0.2,
    style: {
      stopColor: "#A7E0F2",
      stopColor: "color(display-p3 0.6549 0.8784 0.9490)",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_719_2551",
    x1: 133.764,
    y1: 335.261,
    x2: 133.764,
    y2: 319.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB7D9",
    stopOpacity: 0.1,
    style: {
      stopColor: "#4AB7D9",
      stopColor: "color(display-p3 0.2902 0.7176 0.8510)",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7E0F2",
    stopOpacity: 0.2,
    style: {
      stopColor: "#A7E0F2",
      stopColor: "color(display-p3 0.6549 0.8784 0.9490)",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_719_2551",
    x1: 133.764,
    y1: 358.479,
    x2: 133.764,
    y2: 342.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB7D9",
    stopOpacity: 0.1,
    style: {
      stopColor: "#4AB7D9",
      stopColor: "color(display-p3 0.2902 0.7176 0.8510)",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7E0F2",
    stopOpacity: 0.2,
    style: {
      stopColor: "#A7E0F2",
      stopColor: "color(display-p3 0.6549 0.8784 0.9490)",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_719_2551",
    x1: 133.764,
    y1: 381.25,
    x2: 133.764,
    y2: 365.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB7D9",
    stopOpacity: 0.1,
    style: {
      stopColor: "#4AB7D9",
      stopColor: "color(display-p3 0.2902 0.7176 0.8510)",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7E0F2",
    stopOpacity: 0.2,
    style: {
      stopColor: "#A7E0F2",
      stopColor: "color(display-p3 0.6549 0.8784 0.9490)",
      stopOpacity: 0.2
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBulb);
export default __webpack_public_path__ + "static/media/icon-bulb.52081ce4cc7e61ed4e492b207965ed94.svg";
export { ForwardRef as ReactComponent };